import React, { useContext, useEffect } from 'react';
import ExpansionPanel from '../../reusable/ExpansionPanel/ExpansionPanel.js';
import ProgramMatchCard from './ProgramMatchCard.js';
import GeneralEmptyState from '../../reusable/EmptyState/GeneralEmptyState/GeneralEmptyState.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import { NO_DATA_FOUND } from '../../../static/constants.js';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';
import { getSimilarPrograms } from '../../../services/programService.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { LoaderContext } from '../../../contexts/loaderContext.js';
import DefaultBenchmarkEmptyState from './DefaultBenchmarkEmptyState.js';
import '../CostBenchmark.scss';

const ProgramTab = () => {
  const { loading, setLoading } = useContext(LoaderContext);
  const { paginatedPrograms, currPage, loadedPrograms, setLoadedPrograms } = useContext(CostBenchmarkContext);
  const { nameConventions } = useNameConventions();

  const fetchSimilarPrograms = async (similarProgramsIds, programId, isExpanding, distances) => {
    if (!isExpanding || loadedPrograms[programId]) return;

    try {
      setLoading(true);

      const { data } = await getSimilarPrograms(similarProgramsIds);
      const mappedPrograms = data.map((program, index) => {
        return {
          ...program,
          distance: distances[index] || null,
        };
      });
      setLoadedPrograms(prev => ({
        ...prev,
        [programId]: mappedPrograms
      }));
    } catch {
      // error already handled in axios interceptor
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const first = paginatedPrograms[0];

      if (first && !loadedPrograms[first.id] && currPage === 0) {
        await fetchSimilarPrograms(first.similar_programs_ids, first.id, true, first.distances);
      }
    };
    fetchData();
  }, [paginatedPrograms, loadedPrograms]);

  return (
    <div className="flexContainer withGap flexCenter marginTop scrollContainer">
      {!paginatedPrograms || !paginatedPrograms.length ? (
        loading ? <div /> : (
          <DefaultBenchmarkEmptyState/>
        )
      ) : (
        paginatedPrograms.map((data, ind) => (
          <ExpansionPanel
            key={`${data.program}-${ind}`}
            title={data.program}
            open={ind === 0 && currPage === 0}
            onClick={(isExpanding) => fetchSimilarPrograms(data.similar_programs_ids, data.id, isExpanding, data.distances)}
            chipCount={data?.similar_programs_ids?.length || 0}
          >
            <div className="flexContainer withGap">
              {loading ? <div /> : !loadedPrograms[data.id] || !loadedPrograms[data.id].length ? (
                <GeneralEmptyState
                  title={messageManager(nameConventions).COST_BENCHMARK.EMPTY_STATE.NO_SIMILAR_PROGRAMS}
                  src={NO_DATA_FOUND.source}
                  alt={NO_DATA_FOUND.alt}
                  showButton={false}
                />
              ) : (
                loadedPrograms[data.id]?.map((d, index) => (
                  <ProgramMatchCard
                    key={index}
                    data={d}
                    programTotalCost={data.totalCost || 0}
                    className="program-match-card"
                  />
                ))
              )}
            </div>
          </ExpansionPanel>
        ))
      )}
    </div>
  );
};


export default ProgramTab;
